/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Traces_Metadata_ProviderInputs */

const es_admin_traces_metadata_provider = /** @type {(inputs: Admin_Traces_Metadata_ProviderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proveedor`)
};

const en_admin_traces_metadata_provider = /** @type {(inputs: Admin_Traces_Metadata_ProviderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Provider`)
};

/**
* | output |
* | --- |
* | "Provider" |
*
* @param {Admin_Traces_Metadata_ProviderInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const admin_traces_metadata_provider = /** @type {((inputs?: Admin_Traces_Metadata_ProviderInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Traces_Metadata_ProviderInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_admin_traces_metadata_provider(inputs)
	return en_admin_traces_metadata_provider(inputs)
});
export { admin_traces_metadata_provider as "admin.traces.metadata.provider" }